import { Navigate, useSearchParams } from "react-router";
import { sectionOf } from "../features/registers/CaseRegister";

/** The former all-registers page: each register now lives in its section, so old links are forwarded there. */
export function CasesPage() {
  const [params] = useSearchParams();
  const type = params.get("type");
  if (!type) return <Navigate to="/concentration" replace />;
  if (type === "Complaint") return <Navigate to="/investigations?tab=register" replace />;
  if (type === "Whistleblowing") return <Navigate to="/investigations?tab=whistleblowing" replace />;
  return <Navigate to={sectionOf(type).href} replace />;
}
